import React from "react";
import styles from "./styles.module.scss";
import HeaderSection from "../HeaderSection";
import { data } from "./data";
import { Link } from "react-router-dom";
const Testimonials = () => {
  return (
    <>
      <HeaderSection title="What me clients say" />
      <div className={styles.testimonials}>
        {data.map((item) => (
          <div key={item.id} className={styles.testimonials_item}>
            <img src="/assets/images/koteshn.svg" alt="koteshn"/>
            <p>{item.title}</p>
          </div>
        ))}
      </div>
      <div className={styles.testimonials_toutch}>
        <Link to="/contact">Get in touch</Link>
      </div>
    </>
  );
};

export default Testimonials;
